exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spa-claim-modal .modal-body .claim-info{font-size:1.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/tabm/spa-details/components/modal/modal-body.scss
// module id = 5290
// module chunks = 0